import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NiceSelectModule } from "ng-nice-select";
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QrCodeModule } from 'ng-qrcode';

import { SubscriptionComponent } from '@teem/billing-module/components/subscription/subscription.component';
import { AddCardComponent } from '@teem/billing-module/modals/add-card/add-card.component';
import { BillingRoutingModule } from '@teem/billing-module/billing-routing.module';
import { BillingComponent } from '@teem/billing-module/billing.component';
import { ManagePlanComponent } from '@teem/billing-module/components/manage-plan/manage-plan.component';
import { SubscriptionFormComponent } from '@teem/billing-module/components/forms/subscription-form/subscription-form.component';
import { ApplePayComponent } from '@teem/billing-module/components/apple-pay/apple-pay.component';

import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';
import { InvoiceSubscriptionHistoryComponent } from '@teem/billing-module/components/invoice-subscription-history/invoice-subscription-history.component';
import { ViewBillingSubscriptionComponent } from '@teem/billing-module/components/view-billing-subscription/view-billing-subscription.component';


@NgModule({
  declarations: [
    BillingComponent,
    SubscriptionComponent,
    AddCardComponent,
    InvoiceSubscriptionHistoryComponent,
    ViewBillingSubscriptionComponent,
    ManagePlanComponent,
    SubscriptionFormComponent,
    ApplePayComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NiceSelectModule,
    SharedModule,
    CoreModule,
    NgxPaginationModule,
    BillingRoutingModule,
    QrCodeModule
  ]
})
export class BillingModule { }
